
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexMzfyqeuuGIWgswAG3wlvPm_45jpGwrvqqTBuTg_NrAkmMMeta } from "/var/www/html/bp-web-menu-v2/pages/index.vue?macro=true";
import { default as loginCMMBKfjC9zLHCjH4MbuZqDfy1V3pkneDtq5b2wlgEtYMeta } from "/var/www/html/bp-web-menu-v2/pages/login.vue?macro=true";
import { default as checkout_45PUMYhh0i7Q_OINN_45Rhxhp4nENQ8GrnA7M_45h_103aBsMeta } from "/var/www/html/bp-web-menu-v2/pages/checkout.vue?macro=true";
import { default as registeroKj7e64_f2ex6_Ev8CEnL_45_45V6KKrJgN65VVHNu3_452UsMeta } from "/var/www/html/bp-web-menu-v2/pages/register.vue?macro=true";
import { default as indexMK_45Rspz6BdhmOxhkrxepxuHqBta1idx7WIiju8YUlikMeta } from "/var/www/html/bp-web-menu-v2/pages/account/index.vue?macro=true";
import { default as reset_45password61pzBgg8mDS7KkrtPRKDXT6Mtt9oKG75Q22aNw3OfHMMeta } from "/var/www/html/bp-web-menu-v2/pages/reset-password.vue?macro=true";
import { default as forgot_45password87GyQGyacmP5H05QGxPlkXc7JFdhsrsVjA_45PtxOrGF4Meta } from "/var/www/html/bp-web-menu-v2/pages/forgot-password.vue?macro=true";
import { default as addressesXD9OY3A5P_l6CKYlHDyDA3yMBPhtKkySiigmOtpX2_8Meta } from "/var/www/html/bp-web-menu-v2/pages/account/addresses.vue?macro=true";
import { default as index3FwTMNeCZhwvb81Mom79z9qxYJHvuUvMz10WBe5vNQ0Meta } from "/var/www/html/bp-web-menu-v2/pages/account/orders/index.vue?macro=true";
import { default as payment_45methods8sWNEkkD_45BFTWaZAR_uJFQIbeYCUouc_45ImiLTyF3iE0Meta } from "/var/www/html/bp-web-menu-v2/pages/account/payment-methods.vue?macro=true";
import { default as _91orderUuid_93_45_91locationId_93_45_91email_93MuKjDk8ORRrSP9sSG87FGwm39UIVk0maHy5y8ruLepUMeta } from "/var/www/html/bp-web-menu-v2/pages/orders/[orderUuid]-[locationId]-[email].vue?macro=true";
import { default as _91orderUuid_93_45_91locationId_93_45_91email_93q_45vj1A2ihjVuZXmZ3KegcsqKUpmwQbjMXatLSTemevEMeta } from "/var/www/html/bp-web-menu-v2/pages/account/orders/[orderUuid]-[locationId]-[email].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexMzfyqeuuGIWgswAG3wlvPm_45jpGwrvqqTBuTg_NrAkmMMeta || {}), ...{"middleware":["get-root-data","set-color-mode","get-shop-categories","get-structured-data"]} },
    component: () => import("/var/www/html/bp-web-menu-v2/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginCMMBKfjC9zLHCjH4MbuZqDfy1V3pkneDtq5b2wlgEtYMeta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in"]} },
    component: () => import("/var/www/html/bp-web-menu-v2/pages/login.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: { ...(checkout_45PUMYhh0i7Q_OINN_45Rhxhp4nENQ8GrnA7M_45h_103aBsMeta || {}), ...{"middleware":["get-root-data","set-color-mode","has-cart-items"]} },
    component: () => import("/var/www/html/bp-web-menu-v2/pages/checkout.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: { ...(registeroKj7e64_f2ex6_Ev8CEnL_45_45V6KKrJgN65VVHNu3_452UsMeta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in"]} },
    component: () => import("/var/www/html/bp-web-menu-v2/pages/register.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: { ...(indexMK_45Rspz6BdhmOxhkrxepxuHqBta1idx7WIiju8YUlikMeta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in"]} },
    component: () => import("/var/www/html/bp-web-menu-v2/pages/account/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: { ...(reset_45password61pzBgg8mDS7KkrtPRKDXT6Mtt9oKG75Q22aNw3OfHMMeta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in","validate-password-request"]} },
    component: () => import("/var/www/html/bp-web-menu-v2/pages/reset-password.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: { ...(forgot_45password87GyQGyacmP5H05QGxPlkXc7JFdhsrsVjA_45PtxOrGF4Meta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in"]} },
    component: () => import("/var/www/html/bp-web-menu-v2/pages/forgot-password.vue")
  },
  {
    name: "account-addresses",
    path: "/account/addresses",
    meta: { ...(addressesXD9OY3A5P_l6CKYlHDyDA3yMBPhtKkySiigmOtpX2_8Meta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in"]} },
    component: () => import("/var/www/html/bp-web-menu-v2/pages/account/addresses.vue")
  },
  {
    name: "account-orders",
    path: "/account/orders",
    meta: { ...(index3FwTMNeCZhwvb81Mom79z9qxYJHvuUvMz10WBe5vNQ0Meta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in"]} },
    component: () => import("/var/www/html/bp-web-menu-v2/pages/account/orders/index.vue")
  },
  {
    name: "account-payment-methods",
    path: "/account/payment-methods",
    meta: { ...(payment_45methods8sWNEkkD_45BFTWaZAR_uJFQIbeYCUouc_45ImiLTyF3iE0Meta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in"]} },
    component: () => import("/var/www/html/bp-web-menu-v2/pages/account/payment-methods.vue")
  },
  {
    name: "orders-orderUuid-locationId-email",
    path: "/orders/:orderUuid()-:locationId()-:email()",
    meta: { ...(_91orderUuid_93_45_91locationId_93_45_91email_93MuKjDk8ORRrSP9sSG87FGwm39UIVk0maHy5y8ruLepUMeta || {}), ...{"middleware":["get-root-data","set-color-mode","get-valid-order"]} },
    component: () => import("/var/www/html/bp-web-menu-v2/pages/orders/[orderUuid]-[locationId]-[email].vue")
  },
  {
    name: "account-orders-orderUuid-locationId-email",
    path: "/account/orders/:orderUuid()-:locationId()-:email()",
    meta: { ...(_91orderUuid_93_45_91locationId_93_45_91email_93q_45vj1A2ihjVuZXmZ3KegcsqKUpmwQbjMXatLSTemevEMeta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in","get-valid-order"]} },
    component: () => import("/var/www/html/bp-web-menu-v2/pages/account/orders/[orderUuid]-[locationId]-[email].vue")
  }
]